export enum TypeTokensEnum {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}
